const MIN_SEARCH_LENGTH_SUPPLIER = 3;
const MIN_SEARCH_LENGTH_NONVENDOR = 5;

const ErrorMessageEmpty = "Search string is required.";
const ErrorMessageSupplier = `Search string must be at least ${MIN_SEARCH_LENGTH_SUPPLIER} characters.`;
const ErrorMessageNonVendor = `Search string must be at least ${MIN_SEARCH_LENGTH_NONVENDOR} characters.`;

export type SearchValidation = {
    errorMessage?: string;
    isValid: boolean;
};

export function validateSearch(
    query: string,
    supplierId?: string
): SearchValidation {
    let isValid = true;
    let errorMessage = undefined;

    if (!query) {
        errorMessage = ErrorMessageEmpty;
        isValid = false;
    } else if (supplierId) {
        isValid = query.length >= MIN_SEARCH_LENGTH_SUPPLIER;
        if (!isValid) errorMessage = ErrorMessageSupplier;
    } else {
        isValid = query.length >= MIN_SEARCH_LENGTH_NONVENDOR;
        if (!isValid) errorMessage = ErrorMessageNonVendor;
    }
    return {
        isValid,
        errorMessage,
    };
}
